import $ from 'domtastic';
import { events, disableScroll } from '../utils';
import { Starred } from './Starred';
import RentMobile from './RentMobile';

class NavigationMobile {
  constructor() {
    if (!document.querySelector('.js-mobile-nav-invoker')) return;
    this.cacheDom();
    this.bindEvents();
    this.firstOpen = true;
  }

  cacheDom() {
    this.$invoker = $('.js-mobile-nav-invoker');
    this.$close = $('.js-mobile-nav-close');
    this.$menu = $('.js-mobile-nav-menu');
    this.$overlay = $('.js-mobile-overlay');
    this.$container = this.$menu.parent();
    this.$navIcon = this.$menu.find('.js-star-nav');
  }

  bindEvents() {
    this.$invoker.on('click', (event) => {
      event.preventDefault();
      const $invoker = $(event.target);

      if ($invoker.hasClass('-active')) {
        this.close();
      } else {
        this.open($invoker);
      }
    });

    this.$close.on('click', (event) => {
      event.preventDefault();
      this.close();
    });

    events.on('viewportUpdate', breakpoint => this.handleViewport(breakpoint));

    this.$overlay.on('click', () => this.close());
  }

  handleViewport(breakpoint) {
    if (breakpoint !== 'desktop') return;
    this.forceClose();
  }

  open($invoker) {
    disableScroll.lock();

    RentMobile.closeDirect();

    this.showOverlay();
    this.$container.addClass('-active');
    this.$invoker.removeClass('-active');
    $invoker.addClass('-active');
    this.$menu.removeClass('-hidden');
    this.$menu.addClass('-visible');

    events.emit('mobilenavopen', { first: this.firstOpen });
    this.firstOpen = false;
    Starred.setStarState(this.$navIcon);
  }

  close() {
    disableScroll.release();

    this.$invoker.removeClass('-active');
    this.$menu.removeClass('-visible');
    this.$menu.on('transitionend', () => {
      this.$container.removeClass('-active');
      this.$menu.addClass('-hidden');
      this.$menu.off();
    });
    this.hideOverlay();
  }

  forceClose() {
    disableScroll.release();

    this.$invoker.removeClass('-active');
    this.$menu.removeClass('-visible');
    this.$container.removeClass('-active');
    this.$menu.addClass('-hidden');
    this.hideOverlay();
  }

  showOverlay() {
    this.$overlay.addClass('-visible');
  }

  hideOverlay() {
    this.$overlay.removeClass('-visible');
  }
}

export default new NavigationMobile();



// WEBPACK FOOTER //
// ./components/NavigationMobile.js